<template>
  <div>
    <!-- Dialog do periodo da previsão -->
    <p-period-dialog :dialog="periodDialog" @change="val => {periodChangeProcess(val, 'end')}" @close="() => {periodDialog = false}" :dateTime="true" :title="'Previsão'"></p-period-dialog>
    <p-period-dialog :dialog="dateDialog" @change="val => {periodChangeProcess(val, 'created_at')}" @close="() => {dateDialog = false}" :dateTime="true" :title="'Previsão'"></p-period-dialog>
    <p-confirm :text="`Tem certeza que deseja deletar esta ${this.translate('table.task_board.title')[0]}`" entity="none" :dialog="deleteConfirm" @confirm="deleteItem" @cancel="deleteConfirm = false"></p-confirm>
    <!--Create Edit Filtro-->
    <!-- // V-if usado pois no mounted do select monta os valores e precisa ter sido carregado pra depois monta los -->
    <v-dialog v-model="insertDialog" v-if="insertDialog" max-width="800px" persistent scrollable :fullscreen="$vuetify.breakpoint.smAndDown">
      <v-card class="board-card">
        <v-card-title primary-title style="padding-top: 15px;">
          <v-layout align-center justify-space-between>
            <span class="headline">{{view === 2 ? 'Inclusão' : 'Edição'}} de {{this.translate('table.task_board.title')[0]}}</span>
            <v-btn v-if="view === 3" @click="openDeleteDialog()" outline color="pink">Excluir</v-btn>
          </v-layout>
          <v-flex class="board_flex_field" xs12>
            <v-divider class="my-2"></v-divider>
            <v-form ref="formHeader" @keyup.native.enter="save()">
              <v-layout wrap>
                <v-flex xs12 class="board_flex_field">
                  <v-text-field ref="autofocus" validate-on-blur v-model="editedItem.id_text" :rules="requiredRule(`Nome da ${this.translate('table.task_board.title')[0]}`)" :label="`Nome da ${this.translate('table.task_board.title')[0]}*`"></v-text-field>
                </v-flex>
                <!-- So mostra o tipo de seleção quando vai criar, depois o tipo é alterado do lado de fora -->
                <v-flex xs12 class="board_flex_field" v-if="view === 2">
                  <v-item-group v-model="editedItem['properties'].exibitionType">
                    <v-item v-for="(opt, index) in itemsExibitionType" :key="index">
                      <v-chip label color="primary" slot-scope="{ active }" @click="onChangeExibition(opt.value)" :outline="!active" :text-color="active ? 'white' : 'primary'">
                        <v-icon left>{{opt.icon}}</v-icon>{{opt.text}}
                      </v-chip>
                    </v-item>
                  </v-item-group>
                </v-flex>
                <v-flex xs12 class="board_flex_field" v-if="$vuetify.breakpoint.smAndDown">
                  <v-radio-group v-model="editedItem['share_team']" @change="setSwitchShareTeam" row hide-details style="margin:0;padding:0;">
                    <v-radio label="Individual" :value="false"></v-radio>
                    <v-radio label="Compartilhada" :value="true"></v-radio>
                  </v-radio-group>
                </v-flex>
                <v-flex xs12 v-if="editedItem['share_team']" class="board_flex_field">
                  <v-autocomplete validate-on-blur v-model="editedItem['team_id']" :items="taskFilters.taskTeams" item-text="id_text" item-value="id" label="Compartilhar com a equipe" :rules="requiredRule('Equipe')" @change="changeTeam" hide-details></v-autocomplete>
                </v-flex>
              </v-layout>
            </v-form>
          </v-flex>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text style="word-break: break-all;">
          <v-container grid-list-md class="board_flex_field">
            <v-form ref="formContainer">
              <v-layout row justify-space-between wrap>
                <v-flex xs12 class="board_flex_field">
                  <p-select-modal-editable multiple :clearable="false" :label="translate('table.tasks.field.task_status_id')" v-model="editedItem['properties'].status" entity="task_status" item_value="value" id="modal_task_status_id"
                  :itemsProps="taskFilters.taskStatus" :values="status_fields"
                  :companyId="editedItem['company_id']">
                    <v-container grid-list-md>
                      <v-layout wrap>
                        <v-flex xs2>
                          <v-tooltip bottom>
                            <swatches
                              slot="activator"
                              v-model="status_fields.color"
                              colors="material-basic"
                              row-length="4"
                              shapes="circles"
                              popover-to="right"
                              :swatch-style="{ margin: '5px 5px' }"
                              show-fallback
                            ></swatches>
                            <span>Alterar Cor</span>
                          </v-tooltip>
                        </v-flex>
                        <v-flex xs10>
                          <v-text-field id="modalfocus" v-model="status_fields.id_text" :label="translate('table.task_status.field.id_text')"></v-text-field>
                        </v-flex>
                        <v-switch label="Status de conclusão" :value=3 v-model="status_fields.identifier"></v-switch>
                      </v-layout>
                    </v-container>
                  </p-select-modal-editable>
                </v-flex>
                <v-flex xs12 sm6 class="board_flex_field content-template">
                  <v-checkbox class="link-template" v-model="editedItem.link_template" @change="setSwitchLinkTemplate" label="Vincular tarefa modelo" hide-details></v-checkbox>
                  <v-autocomplete v-if="editedItem['link_template']" validate-on-blur v-model="editedItem['tasktemplate_id']" :items="taskFilters['taskTemplates']" item-text="id_text" item-value="id" label="Modelo de Tarefas (POP)" :rules="requiredRule('Tarefa Modelo')" hide-details @change="setSwitchLinkTemplate" :filter="filterAutocomplete"></v-autocomplete>
                  <v-autocomplete v-else multiple validate-on-blur v-model="editedItem['properties'].task_template_id" :items="taskFilters.taskTemplates" item-text="id_text" item-value="id" label="Modelo de Tarefas (POP)" hide-details :filter="filterAutocomplete"></v-autocomplete>
                </v-flex>
                <v-flex xs12 sm6 class="board_flex_field">
                  <p-select-modal-editable id="modal_task_category_id" entity="task_category" multiple :label="translate('table.tasks.field.category_id')" v-model="editedItem['properties'].category" :itemsProps="taskFilters.taskCategories"  :values="category_fields" :clearable="false" :companyId="editedItem['company_id']" item_value="value" >
                    <v-container grid-list-md>
                      <v-layout wrap>
                        <v-flex xs2>
                          <v-tooltip bottom>
                            <swatches
                              slot="activator"
                              v-model="category_fields.color"
                              colors="material-basic"
                              row-length="4"
                              shapes="circles"
                              popover-to="right"
                              :swatch-style="{ margin: '5px 5px' }"
                              show-fallback
                            ></swatches>
                            <span>Alterar Cor</span>
                          </v-tooltip>
                        </v-flex>
                        <v-flex xs10>
                          <v-text-field id="modalfocus" v-model="category_fields.id_text" :label="translate('table.task_category.field.id_text')"></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </p-select-modal-editable>
                </v-flex>
                <v-layout row justify-space-between wrap v-if="showMoreFilterFields">
                  <v-flex xs12 sm6 class="board_flex_field" v-if="!editedItem['share_team']">
                    <v-autocomplete :multiple="!editedItem['share_team']" :disabled="editedItem['share_team']" validate-on-blur v-model="editedItem['properties'].team_id" :items="taskFilters.taskTeams" item-text="id_text" item-value="id" label="Equipe" :hint="editedItem['share_team'] ? `A ${this.translate('table.task_board.title')[0]} está sendo compartilhada com essa equipe` : ''" persistent-hint :filter="filterAutocomplete"></v-autocomplete>
                  </v-flex>
                  <v-flex :class="editedItem['share_team'] ? 'board_flex_field xs12' : 'board_flex_field xs12 sm6'">
                    <v-autocomplete multiple validate-on-blur v-model="editedItem['properties'].user_id" :items="taskFilters.taskUsers" item-text="id_text" item-value="id" @change="val => onUserChange(val)" label="Responsável" :filter="filterAutocomplete">
                      <template v-slot:item="{ item, tile }">
                        <div class="v-list__tile__action">
                          <v-checkbox :disabled="allLess && item.id !== 'allLess'" :input-value="tile.props.value"></v-checkbox>
                        </div>
                        <div class="v-list__tile__content" >
                            <span :style="`color: ${(allLess && item.id !== 'allLess') ? 'grey' : 'black'}`">{{ item.id_text }}</span>
                        </div>
                      </template>
                    </v-autocomplete>
                  </v-flex>
                  <v-flex xs12 sm6 class="board_flex_field">
                    <v-select
                      clearable
                      :items="dateFilterItems"
                      :value="editedItem['properties'].end_period"
                      :label="'Previsão'"
                      @input="(val) => {changePeriodType(val, 'end')}">
                        <template slot='selection' slot-scope='{ item }'>
                          {{ editedItem['properties']['end_period'] !== 'Período' ? editedItem['properties']['end_period'] : `${editedItem['properties']['end_end'] ? '' : 'Desde '}${editedItem['properties']['end_begin'] ? moment(editedItem['properties']['end_begin']).format('DD/MM/YYYY') : ''} ${editedItem['properties']['end_end'] ? 'Até ' + moment(editedItem['properties']['end_end']).format('DD/MM/YYYY') : ''}`}}
                        </template>
                      </v-select>
                  </v-flex>
                  <v-flex xs12 sm6 class="board_flex_field">
                    <v-select
                      clearable
                      :items="dateFilterItems"
                      :value="editedItem['properties'].created_at_period"
                      :label="'Data de Criação'"
                      @input="(val) => {changePeriodType(val, 'created_at')}">
                        <template slot='selection' slot-scope='{ item }'>
                          {{ editedItem['properties']['created_at_period'] !== 'Período' ? editedItem['properties']['created_at_period'] : `${editedItem['properties']['created_at_end'] ? '' : 'Desde '}${editedItem['properties']['created_at_begin'] ? moment(editedItem['properties']['created_at_begin']).format('DD/MM/YYYY') : ''} ${editedItem['properties']['created_at_end'] ? 'Até ' + moment(editedItem['properties']['created_at_end']).format('DD/MM/YYYY') : ''}`}}
                        </template>
                      </v-select>
                  </v-flex>
                  <v-flex xs12 class="board_flex_field">
                    <v-text-field v-model="editedItem['properties'].id_text" label="Descrição"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 class="board_flex_field">
                    <v-autocomplete multiple v-model="editedItem['properties'].client" :items="taskFilters.taskClients" item-text="id_text" item-value="value" label="Cliente" :filter="filterAutocomplete"></v-autocomplete>
                  </v-flex>
                  <v-flex xs12 sm6 class="board_flex_field">
                    <v-select multiple v-model="editedItem['properties'].created_by" :items="taskFilters.createdByUser" item-text="id_text" item-value="id" label="Criado Por"></v-select>
                  </v-flex>
                  <v-flex xs12 sm6 v-if="view === 2" class="board_flex_field">
                    <v-select label="Level" v-model="editedItem['properties']['showTaskLevel']" :items="translate('value.task_filter_level')"></v-select>
                  </v-flex>
                  <v-flex xs12 sm6 v-if="view === 2" class="board_flex_field">
                    <v-layout justify-space-between>
                      <v-autocomplete :disabled="editedItem['properties'].exibitionType === 2" style="display: inline-block;margin-bottom: 0px;margin-top: 8px;" :items="translate('value.task_order_by')"
                        label="Ordenar Por" v-model="editedItem['properties'].sortBy">
                      </v-autocomplete>
                      <div>
                        <span style="cursor: pointer;" @click="editedItem['properties'].descending = !editedItem['properties'].descending">
                          <v-tooltip style="margin-bottom: -10px;" bottom>
                            <v-icon large slot="activator" style="margin-top: 17px;">{{!editedItem['properties'].descending ? 'vertical_align_bottom' : 'vertical_align_top'}}</v-icon>
                            <span>{{!editedItem['properties'].descending ? 'Crescente' : 'Decrescente'}}</span>
                          </v-tooltip>
                        </span>
                      </div>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12>
                    <v-layout>
                      <!-- So mostra o Listar Concluídas quando vai criar, depois o tipo é alterado do lado de fora -->
                      <v-flex xs6 v-if="view === 2">
                        <!-- // caso não seja kanban(this.selectedBoard['properties']['exibitionType'] !== 2) recarrega os registros, caso seja não recarrega -->
                        <v-switch
                          style="margin-top: 0px;"
                          v-model="editedItem['properties']['showFinalized']"
                          :label="$vuetify.breakpoint.smAndDown ? 'Concluídas' : 'Listar Concluídas'"
                          @change="switchFinalized()"
                        ></v-switch>
                      </v-flex>
                      <!-- Listar tarefas parceiras so aparece em areas de trabalho que forem individuais -->
                      <v-flex xs6 v-if="!editedItem['share_team']">
                        <!-- // caso não seja kanban(this.selectedBoard['properties']['exibitionType'] !== 2) recarrega os registros, caso seja não recarrega -->
                        <v-switch
                          style="margin-top: 0px;"
                          v-model="editedItem['properties']['showTaskConnections']"
                          :label="$vuetify.breakpoint.smAndDown ? 'Tarefas de parceiros' : 'Listar tarefas de parceiros'"
                          @change="switchFinalized()"
                        ></v-switch>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>

                <a color="primary" style="padding-top: 10px;" small @click="clickShowMoreFilterFields()">{{showMoreFilterFields ? 'Mostrar menos campos' : 'Mostrar mais campos...'}}<v-icon small>{{showMoreFilterFields ? 'expand_less' : 'expand_more'}}</v-icon></a>
              </v-layout>
            </v-form>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="mx-2" :disabled="loadingCreate" :loading="loadingCreate" color="primary darken-2" @click="save()">Salvar</v-btn>
          <v-btn class="mx-2" @click="close">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- // Lista de Filtros mobile -->
    <v-select class="small-size-illis" v-if="$vuetify.breakpoint.smAndDown" item-text="id_text" item-value="id" :items="boardsAll" :value="selectedBoard['id']" outline dense return-object single-line @change="selectBoard" hide-details >
      <template v-slot:selection="data">
        <v-list-tile-content style="cursor: pointer;" class="handle">
          <v-list-tile-title>
            <v-avatar v-if="data.item.team_id" size="25" :color="data.item.team.color || 'grey'">
              <span class="white--text"> {{ data.item.team_id ? getFirstLetters(data.item.team.id_text) : '' }} </span>
            </v-avatar>
            <v-avatar v-else size="25" >
              <v-icon color="blue">person</v-icon>
            </v-avatar>
            <span style="padding-left:7px;">{{data.item.id_text | formatAbbreviation(20)}}</span>
          </v-list-tile-title>
        </v-list-tile-content>
      </template>
      <template v-slot:prepend-item >
        <v-btn block outline :loading="loading" @click="openInsertDialog" color="primary">Criar</v-btn>
        <v-divider class="mt-2"></v-divider>
      </template>
      <template v-slot:item="{ item }">
        <v-list-tile-content style="cursor: pointer;" class="handle">
          <v-list-tile-title>
            <v-avatar v-if="item.team_id" size="25" :color="item.team.color || 'grey'">
              <span class="white--text"> {{ item.team_id ? getFirstLetters(item.team.id_text) : '' }} </span>
            </v-avatar>
            <v-avatar v-else size="25" >
              <v-icon :color="item.id === selectedBoard['id'] ? 'blue' : 'grey'">person</v-icon>
            </v-avatar>
            <span :style="`padding-left:7px; color:${item.id === selectedBoard['id'] ? 'blue' : 'black'}`">{{item.id_text}}</span>
          </v-list-tile-title>
        </v-list-tile-content>
        <v-list-tile-action v-if="item.id === selectedBoard['id']" >
          <v-tooltip bottom>
            <v-btn slot="activator" class="ma-0" icon @click="editItem()" :disabled="!selectedBoard['hasPermission']">
              <v-icon color="teal">build</v-icon>
            </v-btn>
            <span>{{editText}}</span>
          </v-tooltip>
        </v-list-tile-action>
        <!-- {{item.id_text}}
        <v-spacer></v-spacer>
        <v-tooltip v-if="item.id === selectedBoard['id']" bottom>
          <v-btn class="ma-0" v-if="item.id === selectedBoard['id']" icon @click="editItem()" :disabled="!selectedBoard['hasPermission']">
            <v-icon color="teal">edit</v-icon>
          </v-btn>
          <span>{{editText}}</span>
        </v-tooltip> -->
      </template>
    </v-select>
    <!-- // Lista de Filtros desktop -->
    <v-navigation-drawer
      style="box-shadow: 1px 1px 1px #cecece; margin-right: 10px"
      v-if="!$vuetify.breakpoint.smAndDown"
      width="220"
      mini-variant-width="50"
      permanent
      v-model="drawer"
      :mini-variant="mini"
      hide-overlay
    >
     <!-- style="margin-right: 15px; margin-top: 15px" -->
      <!-- <v-toolbar flat dense style="padding-left: 5px"> -->
      <v-layout align-center justify-space-between >
        <v-toolbar-title style="padding-left: 10px; padding-top: 20px" v-if="!mini">{{this.translate('table.task_board.title')[0]}}</v-toolbar-title>
        <v-btn icon @click.stop="() => {$emit('toggleMini')}" style="margin-right: 15px; margin-top: 27px">
          <v-icon>{{this.mini ? 'chevron_right' : 'chevron_left'}}</v-icon>
        </v-btn>
      </v-layout>
      <div style="overflow-x: hidden; height:70vh">
      <!-- style="overflow: auto;" -->
      <p-task-board-list @editItem="editItem" @changeOrderBoard="changeOrderBoard" @selectBoard="selectBoard" @toggleMini="() => {$emit('toggleMini')}" :boards="boardsIndividual" :selectedBoard="selectedBoard" :mini="mini" :editText="editText" :type="1" @openInsertDialog="openInsertDialog"></p-task-board-list>
      <p-task-board-list @editItem="editItem" @changeOrderBoard="changeOrderBoard" @selectBoard="selectBoard" :boards="boardsShared" @toggleMini="() => {$emit('toggleMini')}" :selectedBoard="selectedBoard" :mini="mini" :editText="editText" :type="2" @openInsertDialog="openInsertDialog"></p-task-board-list>
      </div>

    </v-navigation-drawer>
  </div>
</template>
<script>
  /* eslint-disable eqeqeq, key-spacing, comma-spacing */
  import crud from './../../mixin/crud'
  import rules from './../../mixin/rules'
  import filterTask from './../../mixin/filterTask'
  import general from './../../mixin/general'
  import PConfirm from './../shared/PConfirm'
  import PSelectModalEditable from './../shared/PSelectModalEditable'
  import PSelect from './../shared/PSelect'
  import PTaskBoardList from './../shared/PTaskBoardList'

  import Swatches from 'vue-swatches'
  import moment from 'moment'
  import momentDurationFormatSetup from 'moment-duration-format'

  momentDurationFormatSetup(moment)
  // import crud from '../mixin/crud'
  export default {
    mixins: [crud, rules, general, filterTask],
    components: {PConfirm, PSelectModalEditable, PSelect, Swatches, PTaskBoardList},
    props: {
      mini: false,
      // selectedBoard armazena todos os dados atualizados do board selecionado -->
      selectedBoard: {
        type: Object,
        default: () => { return {} }
      }
    },
    data: () => ({
      // showMoreFilterFields para gerenciar quando esta mostrando todos os campos dos filtros ou não
      showMoreFilterFields: false,
      drawer: true,
      boards: [],
      insertDialog: false,
      // editOrDeleteBoard variavel criada para controlar quando que o usuário clicar para alterar o board no mobile ou quando ele clica para editar e deletar
      editOrDeleteBoardMobile: false,
      entity: 'task_board',
      editText: 'Editar',
      dateFilterItems: [{value: 'Diária', text: 'Diária'}, {value: 'Semanal', text: 'Semanal'}, {value: 'Mensal', text: 'Mensal'}, {value: 'Período', text: 'Período'}],
      editedItem: {},
      defaultItem: {
        id: '',
        id_text: '',
        share_team: false,
        link_template: false,
        tasktemplate_id: '',
        company_id: 0,
        user_id: '',
        // create_user_id precisa vir pois estava armazenando o valor no edited item
        create_user_id: null,
        team_id: '',
        properties: {task_template_id:'',exibitionType:null,id_text:'',team_id:[],user_id:[],category:[],client:[],status:'',end_period:'',created_by:'',sortBy:'created_at',descending:true,showTaskLevel:1,showFinalized:true
        }
      },
      status_fields: {id_text: '', active: true, color: '', identifier: null},
      category_fields: {id_text: '', active: true, color: ''},
      view: 1,
      loadingCreate: false,
      loading: false,
      deleteConfirm: false,
      tempDeleteId: null,
      taskFilters: {},
      boardOrderShared: [],
      boardOrderIndividual: [],
      boardsIndividual: [],
      boardsShared: [],
      // boardsAll vai pro mobile, para msotrar a lsita completa ordenada
      boardsAll: []
    }),
    sockets: {
      // deleteBoard (val) {
      //   this.boards = this.boards.filter((board) => {
      //     return board.id !== val[0]
      //   })
      //   if (val[0] === this.selectedBoard['id']) {
      //     this.$http.get(`api/get_user_boards`).then(res => {
      //       let selectedBoardItem = JSON.parse(JSON.stringify(this.boards.find(board => { return board.id === res.body.selected })))
      //       selectedBoardItem['properties'] = JSON.parse(selectedBoardItem.properties)
      //       this.alterBoard(selectedBoardItem, true)
      //     }, err => {
      //       console.log(err)
      //       this.$store.commit('snackbar/change_values', {
      //         text: `Ocorreu um erro ao carregar os registros do ${this.translate('table.task_board.title')[0]}!`,
      //         color: 'error',
      //         dialog: true
      //       })
      //     })
      //   }
      // },
      socketInsert (val) {
        this.boards.push(val)
      },
      socketEdit (val) {
        Object.assign(this.boards.find((board) => { return board.id === val.id }) || {}, val)
      },
      // Socket acionado quando é feito alguma edição nas categorias, ou cliente ou status. Pois nesses casos o board armaze texto, portanto deve ser alterado o texto dos boards
      socketReloadBoards (val) {
        // chama o selectedBoard/getTaskFilters para recarregar os valores que estão no type
        this.$store.dispatch('selectedBoard/getTaskFilters', {type: val['type']}).then((response) => {
          Object.assign(this.taskFilters, response)
          let selectedBoardItem = val['values']
          selectedBoardItem['properties'] = JSON.parse(selectedBoardItem['properties'])
          this.alterBoard(selectedBoardItem, true, false)
        }, err => {
          console.log(err)
          this.$store.commit('snackbar/change_values', {
            text: `Ocorreu um erro ao carregar os registros, reporte o erro!`,
            color: 'error',
            dialog: true
          })
          this.$store.commit('loader/change_dialog', false)
        })
      }
      // socketSelectBoardUser (selectedBoardItem) {
      //   this.$http.get(`api/select_board/${selectedBoardItem['id']}`).then(res => {
      //     selectedBoardItem['properties'] = JSON.parse(selectedBoardItem.properties)
      //     this.alterBoard(selectedBoardItem, true)
      //   }, err => {
      //     console.log(err)
      //     if (err.body.message === 'noBoardExist') {
      //       this.$store.commit('snackbar/change_values', { text: `Quadro não encontrado! Verifique se esse quadro foi excluido!`, color: 'error', dialog: true })
      //     } else {
      //       this.$store.commit('snackbar/change_values', { text: `Ocorreu um erro ao selecionar o ${this.translate('table.task_board.title')[0]}!`, color: 'error', dialog: true })
      //     }
      //   })
      // }
    },
    created () {
      // inicializa o editedItem para não ter que ficar colocando os valores e preenchendo espaço no data
      this.defaultItem.user_id = this.$auth.user().id
      this.defaultItem.company_id = this.$auth.user().company_id
      this.editedItem = JSON.parse(JSON.stringify(this.defaultItem))
      this.room = `board${this.$auth.user().id}`
      this.mountExibitionType()
      this.$socket.emit('joinRoom', {room: this.room})
    },
    destroyed () {
      this.$socket.emit('leaveRoom', {room: this.room})
      this.$socket.emit('leaveRoom', {room: `selectedBoard${this.selectedBoard['id']}`})
    },
    mounted () {
      // coloca o loading pois precisa carregar a area de trabalho selecionada para ter os valores dela e usar em outros requests como no dashboards
      this.$emit('loadingBoard', true)
      this.$http.get(`api/get_user_boards`).then(res => {
        let filter = this.$store.getters[`filter/values`]
        if (filter['tasks_info']) {
          // Insere a sequencia dos board que vem nos parametros
          if (filter['tasks_info']['boardOrderShared']) this.boardOrderShared = filter['tasks_info']['boardOrderShared']
          if (filter['tasks_info']['boardOrderIndividual']) this.boardOrderIndividual = filter['tasks_info']['boardOrderIndividual']
        }
        this.boards = res.body.boards
        let selectedBoardItem = res.body.selected
        selectedBoardItem['properties'] = JSON.parse(selectedBoardItem.properties)
        // primeira vez que entra seta false pra recarregar pois não tem necessidade de carregar os dados já que o filtindividual filter já faz isso
        this.alterBoard(selectedBoardItem, true, false)
        this.$emit('loadingBoard', false)
      }, err => {
        console.log(err)
        this.$store.commit('snackbar/change_values', {
          text: `Ocorreu um erro ao carregar os registros de ${this.translate('table.task_board.title')[0]}!`,
          color: 'error',
          dialog: true
        })
      })
      this.editedItem['properties'].exibitionType = 1
    },
    methods: {
      // share_team false = individual, true = compartilhado,
      openInsertDialog (shareTeam = 1) {
        // oculta os campos que estavam abertos
        this.showMoreFilterFields = false
        this.editedItem = JSON.parse(JSON.stringify(this.defaultItem))
        this.editedItem['share_team'] = shareTeam
        this.loadFilterItens('create', ['taskStatus', 'taskTemplates', 'taskTeams', 'taskCategories'])
        this.mountExibitionType()
        // if (!this.filterItensLoaded) {
        //   this.loadFilterItens('board').then(res => {
        //     this.filterItensLoaded = true
        //     this.insertDialog = !this.insertDialog
        //     this.view = 2
        //     // Já inclui os três status padrões quando vai criar um quadro
        //     if (this.taskFilters['defaultStatus']) {
        //       this.editedItem['properties'].status = this.taskFilters['defaultStatus']
        //     }
        //   })
        // } else {
        //   this.insertDialog = !this.insertDialog
        //   this.view = 2
        //   // Já inclui os três status padrões quando vai criar um quadro
        //   if (this.taskFilters['defaultStatus']) {
        //     this.editedItem['properties'].status = this.taskFilters['defaultStatus']
        //   }
        // }
        this.editedItem['properties'].exibitionType = 0
      },
      editItem () {
        // oculta os campos que estavam abertos
        this.showMoreFilterFields = false
        // usado o Object.assign pois estava perdendo a referencia no share_team
        Object.assign(this.editedItem, JSON.parse(JSON.stringify(this.selectedBoard)))
        // Verifica se tem team, pois se tiver significa que o filtro é compartilhado
        this.editedItem['share_team'] = !!this.editedItem['team_id']
        // Verifica se tem tasktemplate, pois se tiver significa que está vinculado com uma tarefa
        this.editedItem['link_template'] = !!this.editedItem['tasktemplate_id']
        this.loadFilterItens('edit')
        this.mountExibitionType()
        // if (!this.filterItensLoaded) {
        //   this.loadFilterItens('board').then(res => {
        //     this.checkProperties()
        //     this.filterItensLoaded = true
        //     this.insertDialog = !this.insertDialog
        //     this.view = 3
        //   })
        // } else {
        //   this.checkProperties()
        //   this.insertDialog = !this.insertDialog
        //   this.view = 3
        // }
      },
      deleteItem (id = this.tempDeleteId) {
        let boardsIndividual = this.boards.filter(val => { return val.team_id === null })
        // Não permite excluir todos os quadros individuais
        if (boardsIndividual.length === 1 && boardsIndividual[0]['id'] === id) {
          this.$store.commit('snackbar/change_values', {
            text: `É necessário ter pelo menos uma ${this.translate('table.task_board.title')[0]} individual!`,
            color: 'warning',
            dialog: true
          })
          this.deleteConfirm = false
          return
        }
        this.$http.delete('api/task_board/' + id).then(res => {
          this.$store.commit('snackbar/change_values', {
            text: `Registro de ${this.translate('table.task_board.title')[0]} deletado com sucesso!`,
            color: 'success',
            dialog: true
          })
          this.boards = this.boards.filter((board) => {
            return board.id !== id
          })
          this.$socket.emit('generalEvent', {
            data: [this.tempDeleteId],
            responseEvent: 'deleteBoard',
            room: this.room
          })
          this.close()
          // ao terminar de deletar, verifica se foi deletado o primeiro registro, se sim seleciona o segundo, se não, seleciona o primeiro
          if (boardsIndividual[0]['id'] === id) {
            this.selectBoard(boardsIndividual[1])
          } else {
            this.selectBoard(boardsIndividual[0])
          }
          // this.$socket.emit('generalEvent', {
          //   data: [this.tempDeleteId],
          //   responseEvent: 'deleteBoard',
          //   room: this.room
          // })
        }, err => {
          console.log(err)
          this.$store.commit('snackbar/change_values', {
            text: `Ocorreu um erro ao deletar o registro de ${this.translate('table.task_board.title')[0]}!`,
            color: 'error',
            dialog: true
          })
        })
        this.deleteConfirm = false
      },
      // qualquer alteração feita no board deverá ser atualizada
      alterBoard (selectedBoardItem, cleanSearch = true, changePage = true) {
        // Quando o usuário troca de sala, tira o usuário da sala antiga e inclui na nova.
        this.$socket.emit('leaveRoom', {room: `selectedBoard${this.selectedBoard['id']}`})
        this.$socket.emit('joinRoom', {room: `selectedBoard${selectedBoardItem['id']}`})

        // Joga os valores novos do board pois eles são usados em alguns lugares como nos campos de adicioanr e editar tarefas, no campo de status
        this.$store.commit('selectedBoard/change_board', selectedBoardItem)
        // manda o quadro com as propriedades do quadro para o task para ficar tudo atualizado
        // inclui o cleanSearch para limpar o pesquisar
        // inclui o changePage para atualizar a pagina, em alguns caso não precisa, exemplo quando algum item de categoria, ou status ou client pelo socket
        this.$emit('onBoardChange', Object.assign(selectedBoardItem, {cleanSearch: cleanSearch, changePage: changePage}))
        setTimeout(() => {
          // monta o texto(tootip) da edição de acordo com o acesso
          this.editText = this.getEditText()
        }, 1000)
      },
      onChangeExibition (value) {
        this.editedItem['properties'].exibitionType = value
        this.editedItem['properties'].sortBy = value === 2 ? 'status_update' : 'created_at'
        this.editedItem['properties'].descending = true
      },
      verifyInFilter (task) {
        const props = JSON.parse(JSON.stringify(this.selectedBoard['properties']))
        let result = true
        // Apenas verifica se tem que inserir a tarefa se a tarefa for da mesma empresa do usuário ou se o usuário tiver conexão com a tarefa
        if (task['company_id'] === this.$auth.user()['company_id'] || task['connection_company_id'] === this.$auth.user()['company_id']) {
          Object.entries(props).forEach(entry => {
            // if ((!Array.isArray(entry[1]) && entry[1] != '') || (Array.isArray(entry[1]) && entry[1].length > 0)) {
            if (entry[1] != '' && entry[1] != []) {
              switch (entry[0]) {
                case 'task_template_id':
                  // A tarefa modelo pode vir como integer quando tem alguma vinculada ou como array quando não tem nenhuma vinculada
                  if (result) {
                    result = Array.isArray(entry[1]) ? entry[1].includes(task.tasktemplate_id) : entry[1] == task.tasktemplate_id
                  }
                  break
                case 'team_id':
                  // A equipe pode vir como integer quando tem alguma vinculada ou como array quando não tem nenhuma vinculada
                  if (result) {
                    result = Array.isArray(entry[1]) ? entry[1].includes(task.team_id) : entry[1] == task.team_id
                  }
                  break
                case 'category':
                  result = result && (task.category ? entry[1].includes(task.category.id_text) : false)
                  break
                case 'client':
                  result = result && (task.client ? entry[1].includes(task.client.id_text) : false)
                  break
                case 'status':
                  result = result && (task.status ? entry[1].includes(task.status.id_text) : false)
                  break
              }
              if (!result) return false
            }
          })
        } else {
          return false
        }
        return result
      },
      loadFilterItens (typeView = '', type = '') {
        this.loading = true
        this.$store.commit('loader/change_dialog', true)
        this.$store.dispatch('selectedBoard/getTaskFilters', {type: type}).then((response) => {
          // usa o Object.assign pois nem sempre vem todos os valores, portanto deve substituir apenas os que vem
          this.taskFilters = response
          this.allItemsTasktemplate = response['taskTemplates']
          // usa o change team para filtrar as tarefas modelo da equipe
          this.changeTeam(this.editedItem['properties'].team_id)
          if (typeView === 'create') {
            this.insertDialog = !this.insertDialog
            this.view = 2
            // Já inclui os três status padrões quando vai criar um quadro
            if (this.taskFilters['defaultStatus']) {
              this.editedItem['properties'].status = this.taskFilters['defaultStatus']
            }
          } else if (typeView === 'edit') {
            this.checkProperties()
            this.filterItensLoaded = true
            this.insertDialog = !this.insertDialog
            this.view = 3
            // cai no else quanod clica em mostra mais campos
          } else {
            if (this.view === 3) this.checkProperties()
          }
        }, err => {
          console.log(err)
          this.$store.commit('snackbar/change_values', {
            text: `Ocorreu um erro ao carregar os registros de ${this.translate('table.task_board.title')[0]}!`,
            color: 'error',
            dialog: true
          })
        }).finally(() => {
          this.loading = false
          this.$store.commit('loader/change_dialog', false)
        })
        //  return new Promise((resolve, reject) => {
        //     this.loading = true
        //     this.$store.commit('loader/change_dialog', true)
        //     this.$http.get(`api/get_task_filters${type ? '?type=' + type : ''}`).then(res => {
        //       this.taskFilters = res.body
        //       this.allItemsTasktemplate = res.body['taskTemplates']
        //       // usa o change team para filtrar as tarefas modelo da equipe
        //       this.changeTeam(this.editedItem['properties'].team_id)
        //       resolve(true)
        //     }, err => {
        //       console.log(err)
        //       this.$store.commit('snackbar/change_values', {
        //         text: `Ocorreu um erro ao carregar os registros de ${this.translate('table.task_board.title')[0]}!`,
        //         color: 'error',
        //         dialog: true
        //       })
        //       reject(err)
        //     }).finally(() => {
        //       this.loading = false
        //       this.$store.commit('loader/change_dialog', false)
        //     })
        //   })
      },
      clickShowMoreFilterFields () {
        this.loadFilterItens()
        // Caso todos os valores do filtro não tenham sido carregados, busca eles no banco
        // if (!this.filterAllItensLoaded) {
        //   this.loadFilterItens().then(res => {
        //     this.filterAllItensLoaded = true
        //     // quando é edição verifica se algum item foi apagado
        //     if (this.view === 3) this.checkProperties()
        //   })
        // }
        this.showMoreFilterFields = !this.showMoreFilterFields
      },
      openDeleteDialog (boardId = this.editedItem['id']) {
        this.tempDeleteId = boardId
        this.deleteConfirm = true
      },
      setSwitchShareTeam (val) {
        // caso o usuário tenha apenas uma area individual e tente muda la para compartilhada não permite
        if (val) {
          let boardsIndividual = this.boards.filter(val => { return val.team_id === null })
          // Não permite ficar sem pelo menos uma areaa individual
          // também verifica o view pois esssa verificação não afz sentido quando está incluindo
          if (boardsIndividual.length === 1 && boardsIndividual[0]['id'] === this.selectedBoard['id'] && this.view != 2) {
            // setTimeOut para dar tempo de voltar pro individual
            setTimeout(() => {
              this.editedItem['share_team'] = false
            }, 100)
            this.$store.commit('snackbar/change_values', {
              text: `É necessário ter pelo menos uma ${this.translate('table.task_board.title')[0]} individual!`,
              color: 'warning',
              dialog: true
            })
            return
          }
          // ao alterar a equipe no compartilhamento, deve alterar os filtros também
          this.editedItem['properties']['team_id'] = this.editedItem['team_id']
          this.editedItem['user_id'] = ''
        } else {
          // caso esteja desabilitado insere apenas o usuário
          this.editedItem['user_id'] = this.$auth.user().id
          this.editedItem['properties']['team_id'] = ''
          this.editedItem['team_id'] = ''
        }
        this.mountExibitionType()
        // Filtras as tarefas modelo
        // caso seja desmarcado chama o changeTeam para restruturar a tarefa modelo e passa null para buscar todos os modelos
        this.changeTeam(val ? this.editedItem['team_id'] : null)
      },
      setSwitchLinkTemplate (val) {
        // caso o vincular tarefa modeloa esteja habilitado insere a modelo no tasktemplate_id
        if (val) {
          this.editedItem['properties']['task_template_id'] = this.editedItem['tasktemplate_id']
        } else {
          // caso esteja desabilitado zera a tarefa modelo, pois so mostra a tarefa modeloa com o vincular tarefa modelo habilitado
          this.editedItem['properties']['task_template_id'] = ''
          this.editedItem['tasktemplate_id'] = ''
        }
      },
      // verifica se alguma propriedade está selecionada porem não está na lista, significando que ela foi deletada
      // checkProperties () {
      //   // Percorre todas as propriedades e verifica se os itens são arrays para poder ver se o item selecionado existe na lista de registros, caso não exista adiciona um item como deletado
      //   for (var [key, prop] of Object.entries(this.editedItem['properties'])) {
      //     console.log('key', key)
      //     if (Array.isArray(prop) && prop.length > 0) {
      //       switch (key) {
      //         case 'task_template_id':
      //           prop.forEach((val) => {
      //             // caso não tenha o registro adiciona um de excluido
      //             if (!this.taskFilters['taskTemplates'].some((v) => v.id == val)) {
      //               this.taskFilters['taskTemplates'].unshift({id: val, id_text: 'Registro excluído'})
      //             }
      //           })
      //           break
      //         case 'team_id':
      //           prop.forEach((val) => {
      //             // caso não tenha o registro adiciona um de excluido
      //             if (!this.taskFilters['taskTeams'].some((v) => v.id == val)) {
      //               this.taskFilters['taskTeams'].unshift({id: val, id_text: 'Registro excluído'})
      //             }
      //           })
      //           break
      //         case 'category':
      //           console.log('prop', JSON.parse(JSON.stringify(prop)))
      //           console.log('taskCategories', JSON.parse(JSON.stringify(this.taskFilters['taskCategories'])))
      //           prop.forEach((val) => {
      //             // caso não tenha o registro adiciona um de excluido
      //             if (!this.taskFilters['taskCategories'].some((v) => v.value == val)) {
      //               this.taskFilters['taskCategories'].unshift({id: val, id_text: 'Registro excluído'})
      //             }
      //           })
      //           break
      //         case 'status':
      //           prop.forEach((val) => {
      //             // caso não tenha o registro adiciona um de excluido
      //             if (!this.taskFilters['taskStatus'].some((v) => v.value == val)) {
      //               this.taskFilters['taskStatus'].unshift({value: val, id_text: 'Registro excluído'})
      //             }
      //           })
      //           break
      //       }
      //     }
      //   }
      // },
      selectBoard (board) {
        // Caso o board selecionado seja o mesmo que já está selecionado e não esteja em edição, mostra uma msg não buscando os dados novamente. o View = 1 quando edita o filtro pela consulta de tarefas
        if (this.selectedBoard['id'] === board['id'] && this.view == 1) {
          this.$store.commit('snackbar/change_values', {
            text: `Esse filtro já está selecionado!`,
            color: 'info',
            dialog: true
          })
          return
        }
        this.$emit('loadingBoard', true)
        this.$http.get(`api/select_board/${board['id']}`).then(res => {
          let selectedBoardItem = res.body
          selectedBoardItem['properties'] = JSON.parse(selectedBoardItem['properties'])
          // colosa false no changePage pois o recarregamento dos itens é feito pelo individual filter(PFilterTask)
          this.alterBoard(selectedBoardItem, true, false)
          // this.$socket.emit('generalEvent', {
          //   data: board,
          //   responseEvent: 'socketSelectBoardUser',
          //   room: this.room
          // })
        }, err => {
          console.log(err)
          if (err.body.message === 'boardNotExist') {
            this.$store.commit('snackbar/change_values', { text: `${this.translate('table.task_board.title')[0]} não existe! Favor selecionar outro ou recarregar a página.`, color: 'error', dialog: true })
          } else {
            this.$store.commit('snackbar/change_values', { text: `Ocorreu um erro ao selecionar o ${this.translate('table.task_board.title')[0]}!`, color: 'error', dialog: true })
          }
          this.$emit('loadingBoard', false)
        })
      },
      save (item) {
        // inclui o loading create true para não permitir que o usuário clique mais de uma vez no salvar
        this.loadingCreate = true
        setTimeout(() => {
          this.loadingCreate = false
        }, 1000)
        // Existem dois forms um pra aprte do header que vem o titulo e outro pros filtros
        // Tambem é feito a verificação no save pois no editar passa direto pro save
        if ((this.$refs.formHeader && !this.$refs.formHeader.validate()) || (this.$refs.formContainer && !this.$refs.formContainer.validate())) {
          this.$store.commit('snackbar/change_values', {
            text: 'Por favor, corrija as validações antes de salvar!',
            color: 'warning',
            dialog: true
          })
          return
        }
        this.$store.commit('loader/change_dialog', true)
        Object.assign(this.editedItem, item)
        if (this.view === 2) {
          if (Array.isArray(this.editedItem['properties']['status']) && this.editedItem['properties']['status'].length > 0) {
            // Verfica se foi selecionado algum status finalizado, caso tenha sido, o mostra finalizado vem desmarcado
            if (!this.editedItem['properties']['status'].some((val) => { return this.taskFilters['taskStatus'].some((v) => { return v.identifier == 3 && v.id_text == val }) })) {
              this.editedItem['properties']['showFinalized'] = false
            }
          }
          // transforma properties em string pois no banco é salvo em texto
          this.editedItem['properties'] = JSON.stringify(this.editedItem['properties'])
          this.$http.post('api/task_board', this.editedItem).then(res => {
            this.boards.push(res.body)
            this.selectBoard(res.body)
            // apos salvar o quadro, abre já preencher o filtro
            this.$emit('openFilterTask')
            this.$store.commit('loader/change_dialog', false)
            this.$store.commit('snackbar/change_values', {
              text: `Registro de ${this.translate('table.task_board.title')[0]} incluido com sucesso!`,
              color: 'success',
              dialog: true
            })
            this.$socket.emit('generalEvent', {
              data: res.body,
              responseEvent: 'socketInsert',
              room: this.room
            })
          }, err => {
            this.$store.commit('loader/change_dialog', false)
            console.log(err)
            this.$store.commit('snackbar/change_values', {
              text: `Ocorreu um erro ao incluir o registro de ${this.translate('table.task_board.title')[0]}!`,
              color: 'error',
              dialog: true
            })
          }).finally(() => {
            this.close()
          })
        } else if (this.view === 3) {
          this.saveBoardValues()
        }
      },
      // Função também é usada pelo task.vue e no PFilterTask através do refs
      // board usado para quando os registro vem de fora que tras os valores para atualizar, no caso do task.vue e do pfiltertask
      saveBoardValues (board = null) {
        if (board) {
          let boardItem = this.boards.find((item) => { return item.id === board.id })
          // Usa o Object.assign pois estava perdendo a referencia dos campos
          Object.assign(this.editedItem, JSON.parse(JSON.stringify(boardItem)))
          this.editedItem['properties'] = JSON.parse(this.editedItem['properties'])
          // atualiza apenas as propriedades
          Object.assign(this.editedItem['properties'], board['properties'])
        }
        let valuesBoard = JSON.parse(JSON.stringify(this.editedItem))
        // Tranforma as propriedades em string pois no banco são salvas como string
        if (typeof this.editedItem['properties'] === 'object') valuesBoard['properties'] = JSON.stringify(this.editedItem['properties'])
        this.$http.put('api/task_board/' + valuesBoard.id, valuesBoard).then(res => {
          let savedBoard = this.boards.find((board) => { return board.id === res.body.id })
          // Joga os valores salvos no board para alterar a visualização dos quadros
          Object.assign(savedBoard, res.body)
          // Joga os valores novos do board pois eles são usados em alguns lugares como nos campos de adicioanr e editar tarefas, no campo de status
          this.$store.commit('selectedBoard/change_board', this.editedItem)
          this.$store.commit('loader/change_dialog', false)
          this.selectBoard(res.body)
          this.$store.commit('snackbar/change_values', {
            text: `Registro de ${this.translate('table.task_board.title')[0]} alterado com sucesso!`,
            color: 'success',
            dialog: true
          })
          this.$socket.emit('generalEvent', {
            data: res.body,
            responseEvent: 'socketEdit',
            room: this.room
          })
          let selectedBoardItem = JSON.parse(JSON.stringify(savedBoard))
          selectedBoardItem['properties'] = JSON.parse(selectedBoardItem.properties)
          //  o View === 1 quando edita o filtro pela consulta de tarefas e como não entra no alterboard pelo selectBoard, então entra direto no alterboard
          if (this.view === 1) this.alterBoard(selectedBoardItem, true)
          // Altera a orde pois quando é alterado para quadro compartilhado ou para individual o quadro deve mudar de lugar
          this.orderBoards()
        }, err => {
          this.$store.commit('loader/change_dialog', false)
          console.log(err)
          this.$store.commit('snackbar/change_values', {
            text: `Ocorreu um erro ao alterar o registro de ${this.translate('table.task_board.title')[0]}!`,
            color: 'error',
            dialog: true
          })
        }).finally(() => {
          this.close()
        })
      },
      // função criada para setar pelo componente mae, valores nas propriedades dos filtros, como o status quando ao selecionar a opção listar finalizadas e não ter nenhum status de finalização selecionado
      setFiltersValues (properties) {
        let selectedBoardItem = this.boards.find(board => {
          return board.id === this.selectedBoard['id']
        })
        if (selectedBoardItem) {
          let selectedProps = JSON.parse(selectedBoardItem.properties)
          Object.assign(selectedProps, properties)
          selectedBoardItem.properties = JSON.stringify(selectedProps)
        }
      },
      // função feita para salvar a ordem dos status no filtros
      // type 1 = individual, 2 - compartilhado
      changeOrderBoard (boards, type) {
        // Recebe os itens ordenados e cria a lista de ids ordenados
        let orderIds = boards.map((val) => { return val.id })
        // pega a lista de ids ordenados e manda pra salvar no banco
        if (type === 1) {
          this.boardOrderIndividual = orderIds
          this.orderBoards()
          this.$emit('changeOrderBoard', 'boardOrderIndividual', orderIds)
        } else {
          this.boardOrderShared = orderIds
          this.orderBoards()
          this.$emit('changeOrderBoard', 'boardOrderShared', orderIds)
        }
      },
      close () {
        this.view = 1
        Object.assign(this.editedItem, JSON.parse(JSON.stringify(this.defaultItem)))
        this.insertDialog = false
      },
      getEditText () {
        if (this.selectedBoard['hasPermission']) {
          return 'Editar'
        } else {
          if (this.selectedBoard['create_user'] && this.selectedBoard['create_user']['id_text']) {
            if (this.selectedBoard['team_id']) {
              return 'Apenas administradores da empresa, responsáveis da equipe ou ' + this.selectedBoard['create_user']['id_text'] + ' podem editar essa ' + this.translate('table.task_board.title')[0]
            } else {
              return 'Apenas administradores da empresa ou ' + this.selectedBoard['create_user']['id_text'] + ' podem editar essa ' + this.translate('table.task_board.title')[0]
            }
          } else {
            return 'Apenas administradores da empresa, responsáveis da equipe ou o criado podem editar esse ' + this.translate('table.task_board.title')[0]
          }
        }
      },
      orderBoards () {
        // serve para verificar se está no final da ordenação toda, para incluir na variavel baordsAll
        let isFinal = false
        // Ordena os boards Individuais
        let boardsIndividual = this.boards.filter((board) => { return board.team_id === null })
        this.boardsIndividual = []
        // verifica se tem ordenação, caso não tenha insere o valor total
        if (this.boardOrderIndividual.length > 0) {
          this.boardOrderIndividual.forEach((val, index) => {
            let selected = boardsIndividual.splice(boardsIndividual.findIndex((v) => v.id === val), 1)
            if (selected.length > 0) this.boardsIndividual.push(selected[0])
            // Quando chega no ultimo concatena os restantes no inicio, pois pode ser algum board novo
            if ((index + 1) === this.boardOrderIndividual.length) {
              Array.prototype.unshift.apply(this.boardsIndividual, boardsIndividual)
              // isFinal, verifica se está no fim do processo para criar a variave com todos os quadros
              if (isFinal) {
                // Criar uma variavel com todos os quadros para ser usada no mobile
                this.boardsAll = this.boardsIndividual.concat(this.boardsShared)
              }
              isFinal = true
            }
          })
        } else {
          Array.prototype.unshift.apply(this.boardsIndividual, boardsIndividual)
          // isFinal, verifica se está no fim do processo para criar a variave com todos os quadros
          if (isFinal) {
            // Criar uma variavel com todos os quadros para ser usada no mobile
            this.boardsAll = this.boardsIndividual.concat(this.boardsShared)
          }
          isFinal = true
        }
        // Ordena os boards compartilhados
        let boardsShared = this.boards.filter((board) => { return board.team_id !== null })
        this.boardsShared = []
        // verifica se tem ordenação, caso não tenha insere o valor total
        if (this.boardOrderShared.length > 0) {
          this.boardOrderShared.forEach((val, index) => {
            let selected = boardsShared.splice(boardsShared.findIndex((v) => v.id === val), 1)
            if (selected.length > 0) this.boardsShared.push(selected[0])
            // Quando chega no ultimo concatena os restantes no final
            if ((index + 1) === this.boardOrderShared.length) {
              Array.prototype.unshift.apply(this.boardsShared, boardsShared)
              // isFinal, verifica se está no fim do processo para criar a variave com todos os quadros
              if (isFinal) {
                // Criar uma variavel com todos os quadros para ser usada no mobile
                this.boardsAll = this.boardsIndividual.concat(this.boardsShared)
              }
              isFinal = true
            }
          })
        } else {
          Array.prototype.unshift.apply(this.boardsShared, boardsShared)
          // isFinal, verifica se está no fim do processo para criar a variave com todos os quadros
          if (isFinal) {
            // Criar uma variavel com todos os quadros para ser usada no mobile
            this.boardsAll = this.boardsIndividual.concat(this.boardsShared)
          }
          isFinal = true
        }
      },
      mountExibitionType () {
        this.itemsExibitionType = JSON.parse(JSON.stringify(this.translate('value.board_type')))
        // caso o usuário não tenha permissao pra dashboard ou seja uma area de trabalho comparitlhado, não mostra o item de dashboard
        if (!this.checkPermission('dashboard_custom', 'view') || (this.editedItem['share_team'])) {
          this.itemsExibitionType.pop()
          // Caso o tipo esteja na dashboard, volta pra lista
          if (this.editedItem['properties'].exibitionType === 3) this.editedItem['properties'].exibitionType = 0
        }
      }
    },
    watch: {
      // Quando altera o board, reordena
      boards: {
        handler () {
          this.orderBoards()
        }
      }
    }
  }
</script>

<style scoped>
  .board_flex_field {
    padding-top: 0px !important;
    padding-bottom: 0px !important;
  }
  .link-template {
    position: absolute;
    bottom: 0px;
    left: 0;
  }
  .content-template {
    padding-bottom: 25px !important;
    position: relative;
  }

</style>




// WEBPACK FOOTER //
// src/components/shared/PTaskBoard.vue